module.exports = __webpack_public_path__ + "img/parchment background.afb24105.jpg";